<template>
  <div>
    <div style="padding-bottom: 10vh;">
      <appHeader></appHeader>
      <div class="container-fluid mainContainer mt-5">
        <div class="row">
          <div class="container-fluid faq">
            <div class="row faqContainer">
              <div class="col-sm-12 m-auto">
                <h3 class="mt-4 mb-4 font-weight-bold">
                  Frequently Asked Questions
                </h3>
                <div class="col-sm-12 pl-0 pr-0">
                  <ul>
                    <li>
                      <!-- <a
                      class="btn btn-secondary"
                      href="/admin-points-faq/blank-template"
                      >What format do I need to upload a batch of users?</a
                    > -->
                      <div class="w-100 d-flex flex-column">
                        <div
                          class="d-flex align-items-center  justify-content-between"
                        >
                          <p>
                            What format do I need to upload a batch of users?
                          </p>
                          <font-awesome-icon
                            icon="chevron-down"
                            class="m-1"
                            style="color:white;"
                            size="lg"
                            v-on:click="toggleAnswer(0)"
                          />
                        </div>
                        <div v-if="showAnswer[0]">
                          <blankTemplate></blankTemplate>
                        </div>
                      </div>
                    </li>
                    <li>
                      <!-- <a class="btn btn-secondary" href="/admin-points-faq/upload"
                      >I have my Excel or Access File... how do I upload it?</a
                    > -->
                      <div class="w-100 d-flex flex-column">
                        <div
                          class="d-flex align-items-center  justify-content-between"
                        >
                          <p>
                            I have my Excel or Access File... how do I upload
                            it?
                          </p>
                          <font-awesome-icon
                            icon="chevron-down"
                            class="m-1"
                            style="color:white;"
                            size="lg"
                            v-on:click="toggleAnswer(1)"
                          />
                        </div>
                        <div v-if="showAnswer[1]">
                          <upload></upload>
                        </div>
                      </div>
                    </li>
                    <li>
                      <!-- <a class="btn btn-secondary" href="/admin-points-faq/column"
                      >What do all the columns in the Excel or Access File
                      mean?</a
                    > -->
                      <div class="w-100 d-flex flex-column">
                        <div
                          class="d-flex align-items-center  justify-content-between"
                        >
                          <p>
                            What do all the columns in the Excel or Access File
                            mean?
                          </p>
                          <font-awesome-icon
                            icon="chevron-down"
                            class="m-1"
                            style="color:white;"
                            size="lg"
                            v-on:click="toggleAnswer(2)"
                          />
                        </div>
                        <div v-if="showAnswer[2]">
                          <column></column>
                        </div>
                      </div>
                    </li>
                    <li>
                      <!-- <a
                      class="btn btn-secondary"
                      href="/admin-points-faq/co-matrix"
                      >What's my exact location name or location ID?</a
                    > -->
                      <div class="w-100 d-flex flex-column">
                        <div
                          class="d-flex align-items-center  justify-content-between"
                        >
                          <p>What's my exact location name or location ID?</p>
                          <font-awesome-icon
                            icon="chevron-down"
                            class="m-1"
                            style="color:white;"
                            size="lg"
                            v-on:click="toggleAnswer(3)"
                          />
                        </div>
                        <div v-if="showAnswer[3]">
                          <COMatrix></COMatrix>
                        </div>
                      </div>
                    </li>
                    <li>
                      <!-- <a
                      class="btn btn-secondary"
                      href="/admin-points-faq/program"
                      >How do I get my points assigned to the correct
                      program?</a
                    > -->
                      <div class="w-100 d-flex flex-column">
                        <div
                          class="d-flex align-items-center  justify-content-between"
                        >
                          <p>
                            How do I get my points assigned to the correct
                            program?
                          </p>
                          <font-awesome-icon
                            icon="chevron-down"
                            class="m-1"
                            style="color:white;"
                            size="lg"
                            v-on:click="toggleAnswer(4)"
                          />
                        </div>
                        <div v-if="showAnswer[4]">
                          <program></program>
                        </div>
                      </div>
                    </li>
                    <li>
                      <!-- <a
                      class="btn btn-secondary"
                      href="/admin-points-faq/large-files"
                      >How long should it take to upload my file?</a
                    > -->
                      <div class="w-100 d-flex flex-column">
                        <div
                          class="d-flex align-items-center  justify-content-between"
                        >
                          <p>How long should it take to upload my file?</p>
                          <font-awesome-icon
                            icon="chevron-down"
                            class="m-1"
                            style="color:white;"
                            size="lg"
                            v-on:click="toggleAnswer(5)"
                          />
                        </div>
                        <div v-if="showAnswer[5]">
                          <largeFiles></largeFiles>
                        </div>
                      </div>
                    </li>
                    <li>
                      <!-- <a
                      class="btn btn-secondary"
                      href="/admin-points-faq/access-compact"
                      >My Access DB file seems too large. Can I do anything
                      about it?</a
                    > -->
                      <div class="w-100 d-flex flex-column">
                        <div
                          class="d-flex align-items-center  justify-content-between"
                        >
                          <p>
                            My Access DB file seems too large. Can I do anything
                            about it?
                          </p>
                          <font-awesome-icon
                            icon="chevron-down"
                            class="m-1"
                            style="color:white;"
                            size="lg"
                            v-on:click="toggleAnswer(6)"
                          />
                        </div>
                        <div v-if="showAnswer[6]">
                          <accessCompact></accessCompact>
                        </div>
                      </div>
                    </li>
                    <li>
                      <!-- <a class="btn btn-secondary" href="/admin-points-faq/create"
                      >How do I get a table of my current data for updating?</a
                    > -->
                      <div class="w-100 d-flex flex-column">
                        <div
                          class="d-flex align-items-center  justify-content-between"
                        >
                          <p>
                            How do I get a table of my current data for
                            updating?
                          </p>
                          <font-awesome-icon
                            icon="chevron-down"
                            class="m-1"
                            style="color:white;"
                            size="lg"
                            v-on:click="toggleAnswer(7)"
                          />
                        </div>
                        <div v-if="showAnswer[7]">
                          <create></create>
                        </div>
                      </div>
                    </li>
                    <li>
                      <!-- <a
                      class="btn btn-secondary"
                      href="/admin-points-faq/previous-files"
                      >I <em>Built</em> a user file - now what?</a
                    > -->
                      <div class="w-100 d-flex flex-column">
                        <div
                          class="d-flex align-items-center justify-content-between"
                        >
                          <p>I <em>Built</em> a user file - now what?</p>
                          <font-awesome-icon
                            icon="chevron-down"
                            class="m-1"
                            style="color:white;"
                            size="lg"
                            v-on:click="toggleAnswer(8)"
                          />
                        </div>
                        <div v-if="showAnswer[8]">
                          <previousFiles></previousFiles>
                        </div>
                      </div>
                    </li>
                    <li>
                      <!-- <a
                      class="btn btn-secondary"
                      href="/admin-points-faq/change-password"
                      >How do I change usernames and /or passwords?</a
                    > -->
                      <div class="w-100 d-flex flex-column">
                        <div
                          class="d-flex align-items-center  justify-content-between"
                        >
                          <p>How do I change usernames and /or passwords?</p>
                          <font-awesome-icon
                            icon="chevron-down"
                            class="m-1"
                            style="color:white;"
                            size="lg"
                            v-on:click="toggleAnswer(9)"
                          />
                        </div>
                        <div v-if="showAnswer[9]">
                          <changePassword></changePassword>
                        </div>
                      </div>
                    </li>
                    <li>
                      <!-- <a class="btn btn-secondary" href="/admin-points-faq/delete"
                      >How do I delete a record?... all records?</a
                    > -->
                      <div class="w-100 d-flex flex-column">
                        <div
                          class="d-flex align-items-center  justify-content-between"
                        >
                          <p>How do I delete a record?... all records?</p>
                          <font-awesome-icon
                            icon="chevron-down"
                            class="m-1"
                            style="color:white;"
                            size="lg"
                            v-on:click="toggleAnswer(10)"
                          />
                        </div>
                        <div v-if="showAnswer[10]">
                          <delete></delete>
                        </div>
                      </div>
                    </li>
                    <li>
                      <!-- <a
                      class="btn btn-secondary"
                      href="/admin-points-faq/summary"
                      >How do I edit and finalize my uploaded changes?</a
                    > -->
                      <div class="w-100 d-flex flex-column">
                        <div
                          class="d-flex align-items-center  justify-content-between"
                        >
                          <p>How do I edit and finalize my uploaded changes?</p>
                          <font-awesome-icon
                            icon="chevron-down"
                            class="m-1"
                            style="color:white;"
                            size="lg"
                            v-on:click="toggleAnswer(11)"
                          />
                        </div>
                        <div v-if="showAnswer[11]">
                          <summary></summary>
                        </div>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <appFooter></appFooter>
    </div>
    <navigationFooter></navigationFooter>
  </div>
</template>

<script>
import Header from "@/components/Header.vue";
import Footer from "@/components/Footer.vue";
import AdminSidebar from "@/views/admin/AdminSidebar.vue";
import AddPointsStartWith from "@/views/admin/users/addPoints/AddPointsStartWith.vue";
import BlankTemplate from "./BlankTemplate.vue";
import Summary from "./Summary.vue";
import Delete from "./Delete.vue";
import Upload from "./Upload.vue";
import Program from "./Program.vue";
import PreviousFiles from "./PreviousFiles.vue";
import LargeFiles from "./LargeFiles.vue";
import Create from "./Create.vue";
import COMatrix from "./COMatrix.vue";
import Column from "./Column.vue";
import ChangePassword from "./ChangePassword.vue";
import AccessCompact from "./AccessCompact.vue";
import navigationFooter from "../../../components/navigationFooter.vue";
import { mapState } from "vuex";

export default {
  name: "Faq",

  props: {
    activeMenuItem: String,
    activeMenu: String,
  },

  components: {
    delete: Delete,
    COMatrix: COMatrix,
    column: Column,
    changePassword: ChangePassword,
    accessCompact: AccessCompact,
    create: Create,
    largeFiles: LargeFiles,
    previousFiles: PreviousFiles,
    program: Program,
    upload: Upload,
    appHeader: Header,
    appFooter: Footer,
    appAdminSidebar: AdminSidebar,
    appAddPointsStartWith: AddPointsStartWith,
    blankTemplate: BlankTemplate,
    summary: Summary,
    navigationFooter: navigationFooter,
  },

  data() {
    return {
      showAnswer: [],
      show: true,
    };
  },
  beforeMount() {
    this.showAnswer = [
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
    ];
  },
  methods: {
    setActiveMenuItem: function() {
      this.$store.dispatch("adminSidebar/setActive", {
        activeMenuItem: this.activeMenuItem
          ? this.activeMenuItem
          : "usersAddPoints",
        activeMenu: this.activeMenu ? this.activeMenu : "users",
      });
    },
    toggleAnswer(index) {
      this.$set(this.showAnswer, index, !this.showAnswer[index]);
    },
  },

  created() {
    this.setActiveMenuItem();
  },
};
</script>

<style lang="scss" scoped>
body {
  padding-top: 0;
}
.faq {
  color: white;
  ul {
    display: flex;
    flex-direction: column;
    padding: 0;
  }
  li {
    list-style: none;
    display: inline-block;
    margin-bottom: 20px;
    padding: 10px;
    background-color: rgb(150, 167, 175);
    border-radius: 10px;
  }
  p {
    font-weight: bold;
    font-size: 0.9rem;
  }
}
.row.faqContainer {
  margin-top: 3%;
}
.mainContainer {
  min-height: 90vh;
}
</style>
<style lang="scss">
.faq h3 {
  text-align: center;
  &::after {
    content: none;
  }
}
</style>
